import { $, $$ } from 'utils/dom';
import { clamp, isImageLoaded } from 'utils/helper';
import Lightbox from 'modules/Lightbox/Lightbox';
import Bricks from 'bricks.js';
import Shower from 'modules/shower';

const lang = document.documentElement.lang;

class WaterfallColumns {
  constructor(options = {}) {
    this.container = options.container;
    this.loadMoreBtn = options.loadMoreBtn;
    this.filter = options.filter;
    this.initialImages = options.initialImages ?? 7;
    this.onclickImages = options.onclickImages ?? 4;
    this.shuffle = this.container.dataset.shuffle;
    this.mediaQueries = options.mediaQueries
      ? options.mediaQueries
      : [
          { columns: 1, gutter: 0 },
          { mq: '601px', columns: 2, gutter: 20 },
          { mq: '1201px', columns: 3, gutter: 30 },
          { mq: '1441px', columns: 4, gutter: 40 },
        ];
    this.hasLightbox =
      !!this.container &&
      !!$('.waterfall-columns__figure--gallery', this.container);
    this.items = $$('.waterfall-columns__figure', this.container);
    this.filteredItems = this.items;
    this.filterShower = null;
  }

  setFilterOptions() {
    const parser = new DOMParser();
    const filterButton = $('.o-filter__button', this.filter);
    const filterOptionsList = $('.o-filter__options-list', this.filter);
    const options = new Set();

    lang.substring(0, 2) === 'de' ? options.add('Alle') : options.add('All');

    this.items.forEach(item => options.add(item.dataset.tag));

    let index = 0;

    options.forEach(option => {
      const domString = `<li class="o-filter__option" tabindex="0" role="option">${option}</li>`;

      const listOptionNode = parser.parseFromString(domString, 'text/html').body
        .firstChild;

      filterOptionsList.appendChild(listOptionNode);

      listOptionNode.addEventListener('click', () => {
        this.selectOption(listOptionNode, index);
        this.updateFilter();
      });

      listOptionNode.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') {
          this.selectOption(listOptionNode, index);
          filterButton.focus();
          this.updateFilter();
        }
      });

      index++;
    });

    this.filterShower = new Shower({
      target: $('.o-filter__options-wrapper'),
      handler: filterButton,
      easing: 'ease',
      duration: 250,
      initOpened: false,
      openClassName: 'is-open',
    });
    this.filterShower.init();
  }

  selectOption = (optionNode, nodeIndex) => {
    const filterButton = $('.o-filter__button', this.filter);

    filterButton.setAttribute('data-selected-index', nodeIndex);
    filterButton.textContent = optionNode.textContent;
    this.filterShower.close();
  };

  setFilteredItems() {
    const filterButton = $('.o-filter__button', this.filter);
    const selectedOption = filterButton.textContent;

    if (/Alle?/.test(selectedOption) || !filterButton.dataset.selectedIndex) {
      this.filteredItems = [...this.items];
    } else {
      this.filteredItems = [
        ...this.items.filter(item => selectedOption === item.dataset.tag),
      ];
    }
  }

  updateFilter() {
    this.items.forEach(item => (item.dataset.isVisible = 'false'));

    this.setFilteredItems();
    this.loadImages(this.initialImages);
  }

  initMason() {
    this.mason = Bricks({
      container: this.container,
      sizes: this.mediaQueries,
      position: true,
      packed: 'packed',
    })
      .pack()
      .resize(true);

    window.addEventListener('resize', () => this.mason.pack(), {
      passive: true,
    });
  }

  loadImages(n, setFocus) {
    const newItems = this.filteredItems.splice(
      0,
      clamp(n, 0, this.filteredItems.length)
    );
    newItems.forEach(item => {
      item.dataset.loading = 'true';
      item.dataset.isVisible = 'true';
    });
    this.mason.pack();
    setFocus && newItems[0].focus();

    if (!this.filteredItems.length) {
      this.loadMoreBtn && (this.loadMoreBtn.disabled = true);
    } else {
      this.loadMoreBtn && (this.loadMoreBtn.disabled = false);
    }
  }

  initLightbox() {
    new Lightbox(this.container, {
      selector: '.lightbox-toggle',
    }).init();
  }

  shuffleChildren(parent) {
    for (let i = parent.children.length; i >= 0; i--) {
      parent.appendChild(parent.children[(Math.random() * i) | 0]);
    }
  }

  init() {
    if (!this.container) {
      console.error(
        `Please pass a valid container. Container is '${this.container}'`
      );
      return;
    }

    this.shuffle && this.shuffleChildren(this.container);
    this.filteredItems = [...this.items];

    this.initMason();

    if (this.filter) {
      this.setFilterOptions();
      this.setFilteredItems();
    }

    if (this.loadMoreBtn) {
      this.loadImages(this.initialImages);
      this.loadMoreBtn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.loadImages(this.onclickImages, true);
        }
      });
      this.loadMoreBtn.addEventListener('click', () =>
        this.loadImages(this.onclickImages)
      );
    } else {
      this.loadImages(this.items.length);
    }

    this.hasLightbox && this.initLightbox();
  }
}

const $$waterfallColumns = $$('.waterfall-columns');
if ($$waterfallColumns.length) {
  $$waterfallColumns.forEach(container => {
    const wfc = new WaterfallColumns({
      container: $('.waterfall-columns__items', container),
      loadMoreBtn: $('.waterfall-columns__load-more', container),
      filter: $('.o-filter', container),
      initialImages: 6,
      onclickImages: 4,
    });

    // init slider when last image is loaded
    const images = $$('img', container);
    const lastImage = images[images.length - 1];

    isImageLoaded(lastImage).then(response => {
      setTimeout(() => {
        wfc.init();
      }, 100);
    });
  });
}
